import type { AiCellValue } from "./ai-column-cell";

/**
 * How long a queued run may stay `running` before the cell gives up on it.
 *
 * Nothing on the server ever flips a run whose message was lost — a worker that
 * isn't deployed, a message dead-lettered without an answer — so without a
 * cutoff the cell spins forever. Generous because a bulk run queues up to 200
 * cells at once and they all share the one `run_at`.
 */
export const AI_CELL_STALE_AFTER_MS = 60 * 60 * 1000;

/** Running, and recently enough that it may still finish. */
export const isAiCellRunning = (
  cell: AiCellValue | undefined,
  now: number = Date.now()
): boolean => {
  if (cell?.status !== "running") return false;
  const startedAt = cell.run_at ? Date.parse(cell.run_at) : NaN;
  if (Number.isNaN(startedAt)) return true;
  return now - startedAt <= AI_CELL_STALE_AFTER_MS;
};
